export enum GeneratedFileType {
  UserProfileImages = 'user-profile-images',
  ProcessItemFile = 'process-items',
  Templates = 'templates',
  VendorRefDoc = 'vendor-ref-doc',
  VendorLogo = 'vendor-logo',
  VendorOtherDoc = 'vendor-other-doc',
  ProposalDoc = 'proposal-doc',
  ProjectDescriptionDoc = 'project-description-doc',
  GroupProfileImages = 'group-profile-images',
  AIVendorRefDoc = 'ai-vendor-ref-doc',
}

export interface GeneratedFile {
  key: string
  filename: string
  read?: {
    url: string
    expiresIn: number
    created: number
  }
  write?: {
    url: string
    expiresIn: number
    created: number
  }
}
